import { ApolloError } from 'apollo-client'

/**
 * Checks if the ApolloError contains a graphQLError with a specific code.
 */
export function hasGraphQLErrorCode(
  apolloError: ApolloError,
  errorCode: string
): boolean {
  return apolloError.graphQLErrors.some(
    error => error.extensions?.code === errorCode
  )
}
